import logo from './logo.svg';
import './App.css';
import config from './config';
import React, { useContext, useState, useEffect, useReducer } from 'react';
import { SearchContext } from "./context";
import { rootlink, URL_MW, thumbnailConfig, blue } from './config';
import { default_config, default_viewinfo, default_photolist, default_branchlist, default_planlist, imgConfig, category_mapping, menu_mapping, plates, order_mapping_search } from './config';
import './css/common.scss';
import './css/bulma-tune.scss';
/////////////// swiper start 
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Thumbs } from 'swiper/core';
import loadingicon from './img/loading.gif';
import { Navigation, Pagination, Scrollbar, A11y, Lazy } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import ReactTooltip from 'react-tooltip';
/////////////// swiper end 
import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";
import { useNavigate, useParams } from 'react-router-dom';
import $ from "jquery";
import GalleryBlockNav from './GalleryBlockNav';

const GALLERY_ASPECT_RATIO = `${thumbnailConfig.width}/${thumbnailConfig.height}`;
const MORE_VIEW_ASPECT_RATIO = '640/400';

const GalleryMobile = ({ loaded, viewinfo, photolist, planlist, branchlist, onBlockFlatChange }) => {

  const navigate = useNavigate();

  function golink(p) {
    var url = "/mw_v2/viewlist/details/?id=" + p['value'];
    window.open(url, '_blank');
  }

  function ltrbox(action) {
    if (action == "show") {
      // document.getElementById('lightrail').style.display = 'block';
      $("#lightrail").fadeIn(500);
    } else {
      // document.getElementById('lightrail').style.display = 'none';
      $("#lightrail").fadeOut(500);
    }
  }

  useEffect(() => {
    ReactTooltip.rebuild()
  });

  var planslist3d = [];
  if (planlist != null) {
    for (var i = 0; i < planlist.length; i += 4) {
      planslist3d.push([planlist[i], planlist[i + 1], planlist[i + 2], planlist[i + 3]]);
    }
  }

  return (
    <div className="content_desktop container"
      style={{ padding: "20px 40px" }}
    >
      <div className="top_options" style={{
        marginBottom: "10px",
        display: "flex",
        justifyContent: "flex-end"
      }}>
        {/* <div className="opt_back">
          <span
            onClick={() => navigate(-1)}
            style={{
              cursor: "pointer",
              padding: "5px 7px",
              background: blue,
              color: "white",
              border: "1px transparent",
              borderRadius: "6px"
            }}>返回</span>
        </div> */}
      </div>
      <div className="row">
        <div className="col-md-12 mb-4 gallery-controls-panel">
          <GalleryBlockNav
            loaded={loaded}
            viewinfo={viewinfo}
            onBlockFlatChange={onBlockFlatChange}
          />
        </div>
        <div className="photo_list col-md-12 mb-5">
          <div id="photo_desktop" className="prop_tab tab_selected" style={{ minHeight: '28px' }}>
            <span style={{ visibility: loaded ? 'visible' : 'hidden' }}>
              {viewinfo['doc_name']} 室內相及景觀(只作參考)
            </span>
          </div>
          <hr className="hr1"></hr>
          <hr className="hr1"></hr>
          <div className="card-image" style={{ cursor: "pointer" }}>
            <figure className="image">
              {loaded && photolist?.length ? (
                <Swiper
                modules={[Navigation, Pagination, A11y, Lazy]}
                spaceBetween={0}
                slidesPerView={1}
                lazy={true}
                navigation
                // onClick={() => { golink(p) }}
                // pagination={{ clickable: true }}
                onSwiper={() => { console.log('next') }}
              /*onSwiper={(swiper) => console.log(swiper)}*/
              //onSlideChange={(i) => console.log('slide change',i, i.key ,i.counter )}
              >
                {photolist
                  .map(x => {
                    if (typeof x == 'string') return { url: x };
                    return {
                      url: URL_MW + "resize_img_3g.php?flag=1&img=" + x['file_name'] + "&width=" + thumbnailConfig.width + "&height=" + thumbnailConfig.height,
                      type: x['type']
                    }
                  }
                  ).map((p2, index) => {
                    const photoHref = p2.url;
                    if (!photoHref) return null;
                    return <SwiperSlide key={'swiper' + index}>
                      <a
                        data-fancybox="mobile_gallery1"
                        rel="photo_list"
                        data-caption={p2.type}
                        href={photoHref}
                        data-src={photoHref}
                      >
                        <div style={{ aspectRatio: GALLERY_ASPECT_RATIO, overflow: 'hidden', width: '100%' }}>
                          <img
                            loading={index === 0 ? 'eager' : 'lazy'}
                            decoding="async"
                            width={thumbnailConfig.width}
                            height={thumbnailConfig.height}
                            className='noselect img-fluid'
                            style={{ width: "100%", height: '100%', objectFit: "cover" }}
                            src={p2['url']}
                            alt={p2['type'] || ''}
                          />
                        </div>
                        <div className='position-relative'>
                          <span className="text-center"
                            style={{
                              position: "absolute",
                              bottom: "0px",
                              marginLeft: 'auto',
                              marginRight: 'auto',
                              left: '0px',
                              right: '0px',
                              textAlign: 'center',
                              color: "white",
                              fontWeight: "bold",
                              fontSize: "20px",
                              textShadow: "1px 1px black"
                            }}>{p2['type']}</span>
                        </div>
                      </a>
                    </SwiperSlide>
                  })}
              </Swiper>
              ) : (
                <div
                  className="img-place-holder1"
                  style={{ aspectRatio: GALLERY_ASPECT_RATIO, width: '100%' }}
                  aria-hidden="true"
                />
              )}
            </figure>
          </div>
        </div>
        <div className="more_view col-md-12 mb-5">
          <div id="more_view" className="prop_tab tab_selected"> 更多單位</div>
          <hr className="hr1"></hr>
          <hr className="hr1"></hr>
          <Swiper
            modules={[Navigation, Pagination, A11y, Lazy]}
            spaceBetween={0}
            slidesPerView={1}
            lazy={true}
            navigation
            // onClick={() => { golink(p) }}
            pagination={{ clickable: true }}
          // onSwiper={() => { console.log('next') }}
          //onSwiper={(swiper) => console.log(swiper)}//
          //onSlideChange={(i) => console.log('slide change',i, i.key ,i.counter )}
          >
            {(viewinfo['more_option'] !== undefined) ? viewinfo['more_option'].map(p => {
              return (
                <SwiperSlide key={"more_opt_" + p['value']}>
                  <div className="" onClick={() => golink(p)}>
                    <div className="card">
                      <div className="card-image img-place-holder1" style={{ aspectRatio: MORE_VIEW_ASPECT_RATIO, overflow: "hidden", cursor: "pointer" }}>
                        <img
                          className='pointer w-100 h-100'
                          src={p['img']}
                          width={640}
                          height={400}
                          loading="lazy"
                          decoding="async"
                          style={{ objectFit: "contain" }}
                          alt={p['label'] || ''}
                        />
                      </div>
                      <div className="card-content" style={{ paddingTop: "10px", paddingLeft: "10px", paddingRight: "10px", border: "0px solid green" }}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                          <div className="pointer FZH4B" onClick={() => golink(p)} style={{ lineHeight: "24px", fontSize: "24px" }}>{p['label']}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            }) : null
            }
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default GalleryMobile;
